import { useState, useEffect, useCallback } from 'react';
import api from '@helpers/api';

export default function useChargebackDetails(chargebackId) {
    const [chargeback, setChargeback] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchChargeback = useCallback(async () => {
        if (!chargebackId) return;
        setLoading(true);
        setError(null);
        try {
            const { data } = await api.get(`charge/chargeback/${chargebackId}`);
            setChargeback(data);
        } catch (e) {
            console.error('Failed to fetch chargeback details', e);
            setError('Não foi possível carregar os detalhes da contestação.');
        } finally {
            setLoading(false);
        }
    }, [chargebackId]);

    useEffect(() => {
        fetchChargeback();
    }, [fetchChargeback]);

    return {
        chargeback,
        loading,
        error,
        refetch: fetchChargeback,
    };
}
